import moment from 'moment';
import React, { useEffect, useState } from "react";
import S3 from 'react-aws-s3';
import { Oval } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import documentoService from "../services/documento.service";
import fracttalService from "../services/fracttal.service";
import personaService from "../services/persona.service";
import AutoComplete from "./autocomplete.componet";
import AlertDialog from "./cdialog";

/**Material UI */
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { TextField } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from "@mui/material/IconButton";
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DataGrid, esES } from '@mui/x-data-grid';
import { SnackbarProvider, useSnackbar } from 'notistack';


/** Estilos CSS MUI */
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const PersonasDev = () => {
    const [personas, setPersonas] = useState([]);
    const [persona, setPersona] = useState('');
    const [documentos, setDocumentos] = useState([]);
    const [isLoading, setLoading] = useState(false);
    let navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [archivo, setArchivo] = useState('');
    const [nombrearchivo, setNombreArchivo] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [rut, setRut] = useState('');
    const [cc, setCC] = useState([]);
    const [carta, setCarta] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));
    const [newPersona, setNewPersona] = useState([]);

    const retreivePersonas = async () => {
        let personasf = await personaService.getAll();
        if (user.user.correo === "admin@ecora.cl") {
            setPersonas(personasf.data);
        } else {
            if (personasf.data) {
                console.log("Personas", personasf);
                var proyectos = user.user.proyectos;
                var arr = [];
                if (proyectos) {
                    for (var i in proyectos) {
                        var newarr = personasf.data.filter(v => v.ctoDescripcion === proyectos[i].nombre);
                        arr = arr.concat(newarr);
                    }
                }
                setPersonas(arr);
            }
        }
        /* personaService.getAll()
            .then(response => {
                console.log("Personas", response.data);
                //setPersonas(response.data);
                var proyectos = user.user.proyectos;
                var arr = [];
                if(proyectos) {
                    console.log("Proy", proyectos);
                    for(var i in proyectos) {
                        var newarr = response.data.filter(v=>v.ctoDescripcion === proyectos[i].nombre);
                        console.log("New Arr", newarr);
                        arr = arr.concat(newarr);
                        setNewPersona({...newPersona, arr});
                    }
                    console.log("N ARR", newPersona);
                    console.log("arr", arr);
                }
                setPersona([...persona, arr]);
            })
            .catch(e => {
                console.log(e);
            }); */
    };

    useEffect(() => {
        if (!user) return navigate("/login");
        retreivePersonas();
        retreiveCC();
        console.log("User", user.user);
        /* const timer = setInterval(() => {
            retreivePersonaXRut();
          }, 500);
          return () => clearInterval(timer); */
    }, []);

    const retreivePersonaXRut = () => {
        personaService.getPorRut(rut)
            .then(persona => {
                console.log(persona.data[0]);
                setPersona(persona.data[0]);
            });
    }

    const retreiveCC = () => {
        personaService.getCC()
            .then(resp => {
                console.log(resp.data);
                setCC(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const buscarPersona = () => {
        setLoading(true);
        const valor = document.getElementById("autocompletar");
        const r = valor.value.split(' - ');
        const rut2 = r[1];
        //Buscamos a la persona en la BD de UnySoft
        personaService.getPorRut(rut2)
            .then(persona => {
                console.log(persona.data[0]);
                setPersona(persona.data[0]);
                setRut(rut2);
            });

        //Buscamos los documentos de la persona en Fracttal
        console.log(rut2.replace(/\./g, ''));
        const data = {
            rut: rut2.replace(/\./g, '')
        };
        fracttalService.getDocumentos(data)
            .then(f => {
                console.log(f);
                setDocumentos(f.data);
                setLoading(false);
            });
    }

    const desvincular = () => {
        console.log("RUT", persona);
        if(persona.estado_desv === "En Gerencia Op" || persona.estado_desv === "En Proceso de RRHH"
        || persona.estado_desv === "En Finanzas 1" || persona.estado_desv === "En Finanzas 3 (Finiquito)"
        || persona.estado_desv === "En Gerencia General") {
            alert("La persona ya se encuntra en proceso de Desvinculación");
            return;
        }
        if(persona.estado_desv === "Desvinculado") {
            alert("La persona ya se encuentra desvinculada");
            return;
        }
        if(persona.estado_desv === "Desvinculación rechazada por Gerencia") {
            alert("La desvinculación de esta persona fue rechazada por gerencia, por favor comuniquese con su gerencia.");
            return;
        }
        if (!persona) {
            alert("Debe buscar al trabajador primero!");
            return;
        }
        navigate("/finiquito/" + persona.Rut);
    }

    const openModal = () => {
        if (!persona) {
            alert("Debe buscar al trabajador primero!");
            return;
        }
        setOpen(true);
    }
    const closeModal = () => setOpen(false);

    const guardarDocumento = async () => {
        if (!nombrearchivo) {
            enqueueSnackbar('Falta nombre de archivo!', { variant: "error" });
            return;
        }
        if (!archivo) {
            enqueueSnackbar('Falta adjuntar archivo!', { variant: "error" });
            return;
        }
        console.log({
            "Nombre Archivo": nombrearchivo,
            "Documento": archivo[0]
        });
        if (!persona) {
            enqueueSnackbar('Debe buscar a la Persona!', { variant: "error" });
            return;
        }

        //Guardamos documento en S3 AWS
        var dir = persona.Rut.replace(/\./g, '');
        const config = {
            bucketName: 'docreclutav2',
            dirName: dir + "/hojavida",
            acl: 'public-read',
            //dirName: 'photos', /* optional */
            region: 'sa-east-1',
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY
        }
        const ReactS3Client = new S3(config);
        console.log("CONFIG S3", config);
        var extension = archivo[0].name.split('.').pop();
        console.log("EXT", extension);
        var ruta = "";
        window.Buffer = window.Buffer || require("buffer").Buffer;
        let doc = await ReactS3Client.uploadFile(archivo[0], nombrearchivo + "." + extension);
        if (doc) {
            ruta = doc.location;
        } else {
            enqueueSnackbar('Ocurrio un problema al subir el Archivo!', { variant: "error" });
            return;
        }

        //Ingresamos el documento
        documentoService.ingresar({ nombre: nombrearchivo, personaId: persona.id, ruta: ruta })
            .then(resp => {
                console.log(resp);
            })
            .catch(err => {
                console.error(err);
            });
        setArchivo('');
        setNombreArchivo('');
        retreivePersonaXRut();
        closeModal();
    }

    const eliminarDoc = (id) => {
        documentoService.delete(id)
            .then(resp => {
                retreivePersonaXRut();
                enqueueSnackbar('Documento eliminado correctamente!', { variant: "success" });
            })
            .catch(err => {
                console.error(err);
                enqueueSnackbar('Error al elmimnar el documento!', { variant: "error" });
            });
    }

    /** Data de Documentos */
    const columns = [{
        field: "nombre", headerName: "Nombre", flex: 1
    }, {
        field: "ruta", headerName: "Descarga", flex: 1, renderCell: (cellValues) => {
            return (
                <a href={cellValues.row.ruta} target="_blank"><Button variant="contained" endIcon={<AttachFileIcon />}>Descargar</Button></a>
            );
        }
    }, {
        field: "id", headerName: "Eliminar", flex: 1, renderCell: (cellValues) => {
            return (
                <div>
                    <IconButton aria-label="delete" onClick={() => setConfirmOpen(true)}>
                        <DeleteIcon />
                    </IconButton>
                    <AlertDialog
                        title="Eliminar el Documento?"
                        open={confirmOpen}
                        setOpen={setConfirmOpen}
                        onConfirm={() => eliminarDoc(cellValues.row.id)}
                    >
                        Esta seguro de eliminar el Documento?
                    </AlertDialog>
                </div>
            )
        }
    }];

    const columns_desv = [{
        field: 'fecha_desvinculacion', headerName: 'Fecha de Desvinculación', flex: 1, renderCell: (cellValues) => {
            return (
                <p>{moment(cellValues.row.fecha_desvinculacion).format("DD-MM-YYYY")}</p>
            )
        }
    }];

    const onChangeCarta = (e) => {
        if (e.target.checked) {
            setCarta(true);
            setNombreArchivo("CARTA_AVISO");
        } else {
            setCarta(false);
        }
    }

    const irAmutuoAcuerdo = () => {
        if(!persona) {
            alert("Debe buscar a la trabajador en primer lugar!");
            return;
        }
        navigate("/mutuoacuerdo/"+persona.Rut);
    }

    return isLoading ? (
        <div>
            <div className="d-flex justify-content-center">
                <Oval
                    heigth="100"
                    width="100"
                    color='blue'
                    ariaLabel='loading'
                />
            </div>
            <p className="text-center">Cargando ...</p>
        </div>
    ) : (
        <div>
            <div className="row">
                {console.log("New Persona page", personas)}
                <div className="col-12">
                    <div className="text-center">
                        <h2>Datos de Trabajador</h2>
                    </div>
                    <div className="row p-3">
                        <div className="col-md-3">
                            <AutoComplete suggestions={personas.map(({ perApMaterno, perNombre1, perApPaterno, Rut }) => perNombre1 + " " + perApPaterno + " " + perApMaterno + " - " + Rut)} />
                            <div id="rutHelp" className="form-text">Ingresar nombre o Rut (con puntos y guion)</div>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-primary" onClick={buscarPersona}>Buscar</button>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-success" onClick={()=>navigate("/panel")}>Ver Estados</button>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-secondary" onClick={()=>irAmutuoAcuerdo()}>Solicitud de información Mutuo acuerdo</button>
                        </div>
                    </div>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>Rut:</td>
                                <td>{persona.Rut}</td>
                            </tr>
                            <tr>
                                <td>Nombre</td>
                                <td>{persona ? persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno : ""}</td>
                            </tr>
                            <tr>
                                <td>Unidad de Negocio:</td>
                                <td>{persona.ctoDescripcion}</td>
                            </tr>
                            <tr>
                                <td>Cargo:</td>
                                <td>{persona.recDescripcion}</td>
                            </tr>
                            <tr>
                                <td>Fecha Ingreso:</td>
                                <td>{persona ? moment(persona.FechaContratoInicial).local().format('DD/MM/YYYY') : ""}</td>
                            </tr>
                            <tr>
                                <td>Prceso de Desvinculación</td>
                                <td>{persona.estado_desv}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row justify-content-center mb-3">
                <div className="col-6">
                    <h3 className="h3 text-center">Desvinculaciones</h3>
                    <div style={{height: 200, width: '100%', alignItems: 'center'}}>
                        <DataGrid
                            sx={{
                                boxShadow: 2
                            }}
                            rows={persona ? persona.desvinculados : []}
                            columns={columns_desv}
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="text-center">
                        <button className="btn btn-primary" onClick={desvincular}>Desvinvcular</button>
                        {" "}
                        <button className="btn btn-secondary" onClick={openModal}>Hoja de vida</button>
                    </div>
                </div>
            </div>
            <div className="row mt-3 justify-content-center">
                <div className="col-12">
                    <h3 style={{ textAlign: "center" }}>Documentos Complementarios DesvinculaciónVida</h3>
                    <div style={{ height: 350, width: '100%' }}>
                        <DataGrid
                            sx={{
                                boxShadow: 2,
                                border: 2,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={persona ? persona.documento : []}
                            columns={columns}
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        />
                    </div>
                </div>
            </div>
            {/** Modal para ingresasr documentos */}
            <Modal
                open={open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                        Subir Documento
                    </Typography>
                    {/* <FormGroup>
                        <FormControlLabel control={<Checkbox onChange={(e)=>onChangeCarta(e)} />} label="Carta de aviso?" />
                    </FormGroup> */}
                    <Stack spacing={2} direction="row">
                        <TextField
                            label="Nombre Documento"
                            /* value={nombrearchivo} */
                            onChange={(e) => setNombreArchivo(e.target.value)}
                        /* disabled={carta} */
                        />
                        <Button variant="contained" component="label">
                            Subir
                            <input hidden accept="image/*" multiple type="file" onChange={(e) => setArchivo(e.target.files)} />
                        </Button>
                        <LoadingButton
                            color="secondary"
                            //onClick={handleClick}
                            //loading={loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={guardarDocumento}
                        >
                            Guardar
                        </LoadingButton>
                    </Stack>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Ingeso de documento a la hoja de vida del trabajador.
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
};

//export default PersonasDev;
export default function PersonaDevNotistack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <PersonasDev />
        </SnackbarProvider>
    );
}